import { axiosInstanceWithCredentials } from "./base";

export function getSupportedLanguages(params) {
    return axiosInstanceWithCredentials.get("/languages", {
        params
    });
}
export function addSupportedLanguage(data) {
    return axiosInstanceWithCredentials.post("/language/", data)
}

export function deleteSupportedLanguage(id) {
    return axiosInstanceWithCredentials.delete(`/language/${id}`)
}
